import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Container } from "./components";
import {
  InvoiceDetailContext,
  InvoiceDetailStore,
  InvoiceTypeEnum,
} from "./store";

interface InvoiceDetailProps {
  type: InvoiceTypeEnum;
  id: string;
}

const InvoiceDetail = observer(function InvoiceDetail({
  type,
  id,
}: InvoiceDetailProps) {
  const [store] = useState(() => new InvoiceDetailStore(type));
  return (
    <InvoiceDetailContext.Provider value={store}>
      <Container id={id} />
    </InvoiceDetailContext.Provider>
  );
});

export const ProformaDetail = ({ id }: Omit<InvoiceDetailProps, "type">) => {
  return <InvoiceDetail id={id} type={InvoiceTypeEnum.Proforma} />;
};

export const OutgoingDetail = ({ id }: Omit<InvoiceDetailProps, "type">) => {
  return <InvoiceDetail id={id} type={InvoiceTypeEnum.Outgoing} />;
};
